// @flow
import { Component } from 'react';
import { replaceUrlTo } from '../../../utils/url';

type Props = {};

export class RedirectToLandingPage extends Component<Props> {
	componentDidMount() {
		replaceUrlTo(window.location.origin);
	}

	render() {
		return null;
	}
}

export default RedirectToLandingPage;


// WEBPACK FOOTER //
// ./src/components/utils/RedirectToLandingPage/index.js